import { validateNumeric2DArray, validateNumericArray, validateShapesMatch, validateFitted, validatePositiveInteger } from '../utils/validation.js';
import { LinearRegression } from './linear.js';

export class PolynomialRegression {
  constructor(options = {}) {
    this.degree = options.degree || 2;
    validatePositiveInteger(this.degree, 'degree');
    
    this.fitIntercept = options.fitIntercept !== undefined ? options.fitIntercept : true;
    this.includeBias = options.includeBias !== undefined ? options.includeBias : true;
    
    this.model = new LinearRegression({
      fitIntercept: this.fitIntercept,
      normalize: options.normalize || false
    });
    
    this.isFitted = false;
  }

  _transformFeatures(X) {
    if (!Array.isArray(X[0])) {
      X = X.map(val => [val]);
    }
    
    const nSamples = X.length;
    const nFeatures = X[0].length;
    const transformed = [];
    
    for (let i = 0; i < nSamples; i++) {
      const row = [];
      
      for (let degree = 1; degree <= this.degree; degree++) {
        for (let j = 0; j < nFeatures; j++) {
          row.push(Math.pow(X[i][j], degree));
        }
      }
      
      if (this.degree > 1) {
        for (let j = 0; j < nFeatures; j++) {
          for (let k = j + 1; k < nFeatures; k++) {
            row.push(X[i][j] * X[i][k]);
          }
        }
      }
      
      transformed.push(row);
    }
    
    return transformed;
  }

  fit(X, y) {
    if (!Array.isArray(X[0])) {
      X = X.map(val => [val]);
    }
    
    validateNumeric2DArray(X, 'X');
    validateNumericArray(y, 'y');
    validateShapesMatch(X, y);
    
    const XPoly = this._transformFeatures(X);
    this.model.fit(XPoly, y);
    
    this.isFitted = true;
    return this;
  }

  predict(X) {
    validateFitted(this.isFitted, 'PolynomialRegression');
    
    if (!Array.isArray(X[0])) {
      X = X.map(val => [val]);
    }
    
    validateNumeric2DArray(X, 'X');
    
    const XPoly = this._transformFeatures(X);
    return this.model.predict(XPoly);
  }

  score(X, y) {
    validateFitted(this.isFitted, 'PolynomialRegression');
    
    const XPoly = this._transformFeatures(X);
    return this.model.score(XPoly, y);
  }

  get coefficients() {
    return this.model.coefficients;
  }

  get intercept() {
    return this.model.intercept;
  }
}
